window.addEventListener("load", function () {
  const dropdown = document.getElementById("mobile-tabs-dropdown");
  const toggle = document.getElementById("dropdown-toggle");
  const menu = document.getElementById("dropdown-menu");
  if (!menu) return;
  const selected = document.getElementById("ajax-tabs-selected-options");
  const items = menu.querySelectorAll(".tabs-dropdown-item");

  toggle.addEventListener("click", (e) => {
    e.stopPropagation();
    menu.classList.toggle("hidden");
    toggle.querySelector("svg").classList.toggle("rotate-180");
  });

  items.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      selected.textContent = item.textContent;
      menu.classList.add("hidden");
      toggle.querySelector("svg").classList.remove("rotate-180");

      const href = item.getAttribute("href");
      if (href && href !== "#") {
        window.location.href = href;
      }
    });
  });

  document.addEventListener("click", (e) => {
    if (!dropdown.contains(e.target)) {
      menu.classList.add("hidden");
      toggle.querySelector("svg").classList.remove("rotate-180");
    }
  });
});
